import React from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';

import eyeIcon from "../../../../common/images/eyeIcon.png";
import editIcon from "../../../../common/images/editIcon.png";
import trashIcon from "../../../../common/images/trashIcon.png";

const getUserColums = (handleDelete, handleViewDetail, handleEditUser, roleKeyVal, roleKey) =>  {
  return [
    {
      key: 'fullName',
      label: (roleKeyVal === 'super_admin' && roleKey === 'bunk_incharge')?'INCHARGE NAME':'EMPLOYEE NAME',
      render: (row) => {
        const first = row.firstName ?? '';
        const last = row.lastName ?? '';
        return (first + ' ' + last).trim() || '';
      },
    },
    {
      key: 'phone',
      label: 'CONTACT NUMBER',
      render: (row) => row.phone || '',
    },
    {
      key: 'email',
      label: 'EMAIL',
      render: (row) => row.email || '',
    },
    {
      key: 'entities',
      label: 'ASSIGNED BUNK',
      render: (row) => {
        const entityName = row.entities[0]?.name ?? '';
        const entitydistrict = row.entities[0]?.district ?? '';
        const entityState = row.entities[0]?.state ?? '';

        return (
          <>
            <span className="agency-name-txt">{entityName}</span>
            <div className="agency-address1-txt">{entitydistrict}, {entityState}</div>
          </>
        );
      },
    },
    {
      key: 'isActive',
      label: 'STATUS',
      render: (row) => {
        return (row.isActive==true) ? <span className='status-active-cls'>ACTIVE</span> : <span className='status-inactive-cls'>INACTIVE</span>;
      },
    },
    /*{
      key: 'UserPrivilege',
      label: 'User Privileges',
      render: (row) => (
          <Link
            to={`privilege/${row.id}`}
            title="User Privilege"
            className=""
          >
            <button className="btn btn-secondary frm-rollback-btn">
              <i className="mdi mdi-shield-key align-middle"></i> Permissions
            </button>
          </Link>
      ),
    },*/
    {
      key: 'actions',
      label: 'ACTION',
      render: (row) => (
        <>
          {(roleKeyVal === 'super_admin')?<span
            onClick={() => handleViewDetail(row)}
            title="View Details"
            role="button"
            className="text-secondary me-2"
            style={{ cursor: 'pointer' }}
          >
            <img src={eyeIcon} className='action-icons eye-icon' alt='eyeIcon' />
          </span>:<div className='action-td-coverdiv'>
          <span
            onClick={() => handleViewDetail(row)}
            title="View Details"
            role="button"
            className="text-secondary me-2"
            style={{ cursor: 'pointer' }}
          >
            <img src={eyeIcon} className='action-icons eye-icon' alt='eyeIcon' />
          </span>
          <span
            onClick={() => handleEditUser(row)}
            title="Edit"
            role="button"
            className="me-2 text-secondary"
            style={{ cursor: 'pointer' }}
          >
            <img src={editIcon} className='action-icons action-mrg-both edit-icon' alt='editIcon' />
          </span>
          <span
            onClick={() => handleDelete(row.id)}
            title="Delete"
            role="button"
            className="text-danger"
            style={{ cursor: 'pointer' }}
          >
            <img src={trashIcon} className='action-icons trash-icon' alt='trashIcon' />
          </span>
        </div>}
        </>
      ),
    },
  ];
}

export default getUserColums;